"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = require("styled-components");

var _Theme = require("../../../Theme/Theme.variables");

var _IconBase = require("./IconBase");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var Twitter =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Twitter, _PureComponent);

  function Twitter() {
    _classCallCheck(this, Twitter);

    return _possibleConstructorReturn(this, _getPrototypeOf(Twitter).apply(this, arguments));
  }

  _createClass(Twitter, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          style = _this$props.style,
          height = _this$props.height,
          width = _this$props.width;
      var color = (0, _Theme.variables)(this.props)[this.props.color];
      return _react.default.createElement(_IconBase.IconBase, _extends({
        width: width,
        height: height,
        className: className,
        style: style,
        viewBox: "0 0 17 16",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg"
      }, this.props), _react.default.createElement("title", null, "Twitter"), _react.default.createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, _react.default.createElement("g", {
        fill: color
      }, _react.default.createElement("path", {
        d: "M5.6606,15.3145 C12.4536,15.3145 16.1686,9.6865 16.1686,4.8065 C16.1686,4.6475 16.1646,4.4885 16.1576,4.3305 C16.8786,3.8085 17.5056,3.1585 17.9996,2.4185 C17.3386,2.7105 16.6256,2.9095 15.8796,2.9995 C16.6416,2.5425 17.2266,1.8185 17.5026,0.9565 C16.7896,1.3785 15.9996,1.6865 15.1586,1.8525 C14.4846,1.1345 13.5246,0.6855 12.4626,0.6855 C10.4226,0.6855 8.7686,2.3395 8.7686,4.3775 C8.7686,4.6685 8.8016,4.9505 8.8646,5.2205 C5.7956,5.0665 3.0746,3.5965 1.2526,1.3625 C0.9356,1.9075 0.7526,2.5425 0.7526,3.2175 C0.7526,4.4995 1.4046,5.6305 2.3956,6.2925 C1.7906,6.2735 1.2216,6.1075 0.7236,5.8305 C0.7226,5.8455 0.7226,5.8615 0.7226,5.8765 C0.7226,7.6665 1.9956,9.1595 3.6856,9.4985 C3.3756,9.5825 3.0486,9.6275 2.7116,9.6275 C2.4736,9.6275 2.2426,9.6045 2.0176,9.5605 C2.4876,11.0285 3.8506,12.0955 5.4676,12.1265 C4.2036,13.1165 2.6116,13.7075 0.8806,13.7075 C0.5826,13.7075 0.2886,13.6895 -0.0004,13.6555 C1.6346,14.7035 3.5756,15.3145 5.6606,15.3145"
      }))));
    }
  }]);

  return Twitter;
}(_react.PureComponent);

Twitter.displayName = 'Twitter'; // Prop Types

Twitter.propTypes = {
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  width: _propTypes.default.string,
  height: _propTypes.default.string,
  color: _propTypes.default.string
};
Twitter.defaultProps = {
  className: '',
  style: {},
  height: '16',
  width: '17',
  color: 'black'
};

var _default = (0, _styledComponents.withTheme)(Twitter);

exports.default = _default;